import AnchorLink from './AnchorLink';
import Reveal from './Reveal';

export default function CtaBand() {
  return (
    <section aria-labelledby="cta-h" className="mt-sec-y border-y-2 border-ink bg-accent text-ink">
      <Reveal className="container-site flex flex-wrap items-end justify-between gap-8 py-[clamp(56px,8vw,104px)]">
        <h2 id="cta-h" className="text-cta">Have a project<br />in mind?</h2>
        <div className="flex max-w-[360px] flex-col gap-4">
          <p className="text-body font-semibold">Thirty minutes with a senior engineer. You leave with a rough architecture and a timeline range.</p>
          <AnchorLink
            href="#contact"
            className="inline-flex h-btn-lg items-center justify-between gap-7 bg-ink px-5 text-[17px] font-extrabold text-bg transition-transform duration-150 hover:-translate-x-[3px] hover:-translate-y-[3px] hover:shadow-[3px_3px_0_#F3F2F2]"
          >
            Book a free consultation <span aria-hidden="true">→</span>
          </AnchorLink>
        </div>
      </Reveal>
    </section>
  );
}
